module.exports = __webpack_public_path__ + "img/kennebec_camp.06f86f30.png";